module.exports = __webpack_public_path__ + "img/photo-0008.e6b9dfa5.jpg";